
<div class="bubbleContainer">
  <v-btn v-show="! display" class="helpButton" @click="display = true">
    <v-icon>help_outline</v-icon>
    {{ $t('HELP_TITLE') }}
  </v-btn>
  <div v-show="display" class="speech-bubble">
    <v-icon class="hoverPointer closeIcon" @click="close()">close</v-icon>
    <p v-html="$t('HELP_TEXT')"></p>
  </div>
</div>

